import isAfter from 'date-fns/isAfter'
import addDays from 'date-fns/addDays'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} must be at least 5 days(s) from the date of application.`
}

function validate(value, args) {
  if (value) {
    const minDate = removeTime(addDays(new Date(), 5))
    const startDate = removeTime(value)
    if (isAfter(minDate, startDate)) return false
    else return true
  } else return true
}

export default {
  getMessage,
  validate
}
